import { render, staticRenderFns } from "./NavigationCartButton.vue?vue&type=template&id=19bf76a8"
import script from "./NavigationCartButton.vue?vue&type=script&lang=ts"
export * from "./NavigationCartButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports